import React from 'react';

function LogoIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="130"
      height="41"
      fill="none"
      viewBox="0 0 130 41"
      {...props}
    >
      <path
        fill="#132B29"
        d="M15.827 32.294V21.129c0-5.163-2.669-7.514-6.519-7.514-3.663 0-6.439 2.2-6.439 7.29v11.382H0V4.25h2.85v9.983c1.427-2.05 3.816-3.192 6.712-3.192 5.471 0 9.1 3.152 9.1 10.094v11.166l-2.835-.007zM32.081 32.786c-6.559 0-11.303-4.63-11.303-11a10.508 10.508 0 01.82-4.161 10.646 10.646 0 012.401-3.517 10.843 10.843 0 013.605-2.317 10.977 10.977 0 014.237-.75c6.326 0 10.95 4.597 10.95 10.928.007 6.227-4.544 10.817-10.71 10.817zm-.24-19.164c-4.67 0-8.174 3.533-8.174 8.236 0 4.86 3.47 8.347 8.328 8.347 4.59 0 7.907-3.448 7.907-8.196 0-4.749-3.43-8.387-8.06-8.387zM73.37 32.294V20.262c0-4.664-2.115-6.68-5.584-6.68-3.337 0-5.785 1.97-5.785 6.68v12.032h-2.856V20.189c0-4.63-2.47-6.567-5.705-6.567-3.55 0-5.672 2.43-5.672 6.567v12.105h-2.85V11.533h2.85v2.39a6.641 6.641 0 012.58-2.217 6.763 6.763 0 013.359-.666c3.162 0 5.244 1.216 6.906 3.987 1.775-2.771 4.043-4.02 7.34-4.02 4.817 0 8.287 2.917 8.287 8.952v12.335h-2.87zM81.218 22.843a7.966 7.966 0 002.63 5.272 8.214 8.214 0 005.577 2.09 8.1 8.1 0 004.389-1.292 7.913 7.913 0 002.95-3.45h2.97a10.998 10.998 0 01-3.97 5.234 11.274 11.274 0 01-6.286 2.09 11.178 11.178 0 01-4.283-.803 11.04 11.04 0 01-3.632-2.375 10.84 10.84 0 01-2.412-3.575 10.703 10.703 0 01-.816-4.216c-.013-1.42.261-2.828.808-4.143a10.669 10.669 0 012.374-3.512 10.864 10.864 0 013.57-2.333 11.002 11.002 0 014.211-.79c6.245 0 10.99 4.44 10.99 11.823l-19.07-.02zm8.053-9.195a8.086 8.086 0 00-5.27 1.868 7.852 7.852 0 00-2.737 4.812h16.168c-.961-4.165-4.084-6.706-8.174-6.706l.013.026z"
      ></path>
      <mask
        id="mask0_801_6633"
        style={{ maskType: 'luminance' }}
        width="27"
        height="41"
        x="103"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path
          fill="#fff"
          d="M114.146 12.446v-4c.007-.62.263-1.214.711-1.65a2.417 2.417 0 011.685-.681h2.669V0h-2.669a8.665 8.665 0 00-6.064 2.478 8.392 8.392 0 00-2.517 5.968v4h-4.724v6.088h4.744v13.32c0 .625-.252 1.225-.702 1.667a2.413 2.413 0 01-1.693.69h-2.349V40.3h2.349a8.663 8.663 0 006.063-2.478 8.388 8.388 0 002.517-5.968v-13.32h8.735v15.244h6.192V12.446h-14.947z"
        ></path>
      </mask>
      <g mask="url(#mask0_801_6633)">
        <path fill="#FF8A00" d="M103.57 0h-.353v40.3h.353V0z"></path>
        <path fill="#FF8901" d="M103.924 0h-.354v40.3h.354V0z"></path>
        <path fill="#FE8702" d="M104.278 0h-.354v40.3h.354V0z"></path>
        <path fill="#FE8603" d="M104.631 0h-.353v40.3h.353V0z"></path>
        <path fill="#FE8504" d="M104.985 0h-.354v40.3h.354V0z"></path>
        <path fill="#FE8405" d="M105.339 0h-.354v40.3h.354V0z"></path>
        <path fill="#FD8206" d="M105.693 0h-.354v40.3h.354V0z"></path>
        <path fill="#FD8107" d="M106.046 0h-.354v40.3h.354V0z"></path>
        <path fill="#FD8008" d="M106.4 0h-.354v40.3h.354V0z"></path>
        <path fill="#FC7F08" d="M106.753 0h-.354v40.3h.354V0z"></path>
        <path fill="#FC7D09" d="M107.107 0h-.354v40.3h.354V0z"></path>
        <path fill="#FC7C0A" d="M107.467 0h-.354v40.3h.354V0z"></path>
        <path fill="#FC7B0B" d="M107.821 0h-.354v40.3h.354V0z"></path>
        <path fill="#FB7A0C" d="M108.174 0h-.353v40.3h.353V0z"></path>
        <path fill="#FB780D" d="M108.528 0h-.354v40.3h.354V0z"></path>
        <path fill="#FB770E" d="M108.882 0h-.354v40.3h.354V0z"></path>
        <path fill="#FB760F" d="M109.235 0h-.353v40.3h.353V0z"></path>
        <path fill="#FA7510" d="M109.589 0h-.354v40.3h.354V0z"></path>
        <path fill="#FA7411" d="M109.943 0h-.354v40.3h.354V0z"></path>
        <path fill="#FA7211" d="M110.297 0h-.354v40.3h.354V0z"></path>
        <path fill="#FA7112" d="M110.65 0h-.354v40.3h.354V0z"></path>
        <path fill="#F97013" d="M111.004 0h-.354v40.3h.354V0z"></path>
        <path fill="#F96F14" d="M111.357 0h-.354v40.3h.354V0z"></path>
        <path fill="#F96E15" d="M111.711 0h-.354v40.3h.354V0z"></path>
        <path fill="#F96C16" d="M112.071 0h-.353v40.3h.353V0z"></path>
        <path fill="#F86B17" d="M112.425 0h-.354v40.3h.354V0z"></path>
        <path fill="#F86A18" d="M112.778 0h-.353v40.3h.353V0z"></path>
        <path fill="#F86918" d="M113.132 0h-.354v40.3h.354V0z"></path>
        <path fill="#F86819" d="M113.486 0h-.354v40.3h.354V0z"></path>
        <path fill="#F7671A" d="M113.839 0h-.353v40.3h.353V0z"></path>
        <path fill="#F7661B" d="M114.193 0h-.354v40.3h.354V0z"></path>
        <path fill="#F7651C" d="M114.547 0h-.354v40.3h.354V0z"></path>
        <path fill="#F7631D" d="M114.901 0h-.354v40.3h.354V0z"></path>
        <path fill="#F6621D" d="M115.254 0h-.354v40.3h.354V0z"></path>
        <path fill="#F6611E" d="M115.608 0h-.354v40.3h.354V0z"></path>
        <path fill="#F6601F" d="M115.961 0h-.354v40.3h.354V0z"></path>
        <path fill="#F65F20" d="M116.321 0h-.353v40.3h.353V0z"></path>
        <path fill="#F55E21" d="M116.675 0h-.353v40.3h.353V0z"></path>
        <path fill="#F55D21" d="M117.029 0h-.354v40.3h.354V0z"></path>
        <path fill="#F55C22" d="M117.382 0h-.353v40.3h.353V0z"></path>
        <path fill="#F55B23" d="M117.736 0h-.354v40.3h.354V0z"></path>
        <path fill="#F45A24" d="M118.09 0h-.354v40.3h.354V0z"></path>
        <path fill="#F45924" d="M118.443 0h-.353v40.3h.353V0z"></path>
        <path fill="#F45825" d="M118.797 0h-.354v40.3h.354V0z"></path>
        <path fill="#F45726" d="M119.151 0h-.354v40.3h.354V0z"></path>
        <path fill="#F45627" d="M119.505 0h-.354v40.3h.354V0z"></path>
        <path fill="#F35527" d="M119.858 0h-.354v40.3h.354V0z"></path>
        <path fill="#F35428" d="M120.212 0h-.354v40.3h.354V0z"></path>
        <path fill="#F35329" d="M120.565 0h-.354v40.3h.354V0z"></path>
        <path fill="#F35229" d="M120.925 0h-.353v40.3h.353V0z"></path>
        <path fill="#F3512A" d="M121.279 0h-.353v40.3h.353V0z"></path>
        <path fill="#F2502B" d="M121.633 0h-.354v40.3h.354V0z"></path>
        <path fill="#F24F2B" d="M121.986 0h-.353v40.3h.353V0z"></path>
        <path fill="#F24E2C" d="M122.34 0h-.354v40.3h.354V0z"></path>
        <path
          fill="#F24D2D"
          d="M122.694 0h-.354v40.3h.354V0zM123.047 0h-.353v40.3h.353V0z"
        ></path>
        <path fill="#F14C2E" d="M123.401 0h-.354v40.3h.354V0z"></path>
        <path fill="#F14B2F" d="M123.755 0h-.354v40.3h.354V0z"></path>
        <path fill="#F14A2F" d="M124.109 0h-.354v40.3h.354V0z"></path>
        <path fill="#F14930" d="M124.462 0h-.354v40.3h.354V0z"></path>
        <path fill="#F14831" d="M124.816 0h-.354v40.3h.354V0z"></path>
        <path fill="#F04831" d="M125.176 0h-.354v40.3h.354V0z"></path>
        <path fill="#F04732" d="M125.529 0h-.353v40.3h.353V0z"></path>
        <path fill="#F04632" d="M125.883 0h-.353v40.3h.353V0z"></path>
        <path
          fill="#F04533"
          d="M126.237 0h-.354v40.3h.354V0zM126.59 0h-.353v40.3h.353V0z"
        ></path>
        <path fill="#F04434" d="M126.944 0h-.354v40.3h.354V0z"></path>
        <path fill="#F04334" d="M127.298 0h-.354v40.3h.354V0z"></path>
        <path fill="#EF4335" d="M127.651 0h-.353v40.3h.353V0z"></path>
        <path
          fill="#EF4235"
          d="M128.005 0h-.354v40.3h.354V0zM128.359 0h-.354v40.3h.354V0z"
        ></path>
        <path fill="#EF4136" d="M128.713 0h-.354v40.3h.354V0z"></path>
        <path fill="#EF4136" d="M129.066 0h-.354v40.3h.354V0z"></path>
      </g>
      <mask
        id="mask1_801_6633"
        style={{ maskType: 'luminance' }}
        width="8"
        height="8"
        x="122"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path
          fill="#fff"
          d="M126.017 7.842c2.2 0 3.983-1.756 3.983-3.921C130 1.755 128.217 0 126.017 0s-3.984 1.755-3.984 3.921c0 2.165 1.784 3.92 3.984 3.92z"
        ></path>
      </mask>
      <g mask="url(#mask1_801_6633)">
        <path fill="#FF8A00" d="M122.14 0h-.107v7.842h.107V0z"></path>
        <path fill="#FF8901" d="M122.253 0h-.107v7.842h.107V0z"></path>
        <path fill="#FE8702" d="M122.36 0h-.107v7.842h.107V0z"></path>
        <path fill="#FE8603" d="M122.467 0h-.107v7.842h.107V0z"></path>
        <path fill="#FE8504" d="M122.58 0h-.106v7.842h.106V0z"></path>
        <path fill="#FE8405" d="M122.687 0h-.106v7.842h.106V0z"></path>
        <path fill="#FD8206" d="M122.794 0h-.107v7.842h.107V0z"></path>
        <path fill="#FD8107" d="M122.907 0h-.107v7.842h.107V0z"></path>
        <path fill="#FD8008" d="M123.014 0h-.107v7.842h.107V0z"></path>
        <path fill="#FC7F08" d="M123.121 0h-.107v7.842h.107V0z"></path>
        <path fill="#FC7D09" d="M123.234 0h-.107v7.842h.107V0z"></path>
        <path fill="#FC7C0A" d="M123.341 0h-.107v7.842h.107V0z"></path>
        <path fill="#FC7B0B" d="M123.448 0h-.107v7.842h.107V0z"></path>
        <path fill="#FB7A0C" d="M123.561 0h-.106v7.842h.106V0z"></path>
        <path fill="#FB780D" d="M123.668 0h-.107v7.842h.107V0z"></path>
        <path fill="#FB770E" d="M123.775 0h-.107v7.842h.107V0z"></path>
        <path fill="#FB760F" d="M123.888 0h-.107v7.842h.107V0z"></path>
        <path fill="#FA7510" d="M123.995 0h-.107v7.842h.107V0z"></path>
        <path fill="#FA7411" d="M124.108 0h-.107v7.842h.107V0z"></path>
        <path fill="#FA7211" d="M124.215 0h-.107v7.842h.107V0z"></path>
        <path fill="#FA7112" d="M124.322 0h-.107v7.842h.107V0z"></path>
        <path fill="#F97013" d="M124.435 0h-.106v7.842h.106V0z"></path>
        <path fill="#F96F14" d="M124.542 0h-.107v7.842h.107V0z"></path>
        <path fill="#F96E15" d="M124.649 0h-.107v7.842h.107V0z"></path>
        <path fill="#F96C16" d="M124.762 0h-.107v7.842h.107V0z"></path>
        <path fill="#F86B17" d="M124.869 0h-.107v7.842h.107V0z"></path>
        <path fill="#F86A18" d="M124.976 0h-.107v7.842h.107V0z"></path>
        <path fill="#F86918" d="M125.089 0h-.107v7.842h.107V0z"></path>
        <path fill="#F86819" d="M125.196 0h-.107v7.842h.107V0z"></path>
        <path fill="#F7671A" d="M125.303 0h-.107v7.842h.107V0z"></path>
        <path fill="#F7661B" d="M125.416 0h-.106v7.842h.106V0z"></path>
        <path fill="#F7651C" d="M125.523 0h-.107v7.842h.107V0z"></path>
        <path fill="#F7631D" d="M125.63 0h-.107v7.842h.107V0z"></path>
        <path fill="#F6621D" d="M125.743 0h-.107v7.842h.107V0z"></path>
        <path fill="#F6611E" d="M125.85 0h-.107v7.842h.107V0z"></path>
        <path fill="#F6601F" d="M125.963 0h-.107v7.842h.107V0z"></path>
        <path fill="#F65F20" d="M126.07 0h-.107v7.842h.107V0z"></path>
        <path fill="#F55E21" d="M126.177 0h-.107v7.842h.107V0z"></path>
        <path fill="#F55D21" d="M126.29 0h-.106v7.842h.106V0z"></path>
        <path fill="#F55C22" d="M126.397 0h-.107v7.842h.107V0z"></path>
        <path fill="#F55B23" d="M126.504 0h-.107v7.842h.107V0z"></path>
        <path fill="#F45A24" d="M126.617 0h-.107v7.842h.107V0z"></path>
        <path fill="#F45924" d="M126.724 0h-.107v7.842h.107V0z"></path>
        <path fill="#F45825" d="M126.831 0h-.107v7.842h.107V0z"></path>
        <path fill="#F45726" d="M126.944 0h-.107v7.842h.107V0z"></path>
        <path fill="#F45627" d="M127.051 0h-.107v7.842h.107V0z"></path>
        <path fill="#F35527" d="M127.158 0h-.107v7.842h.107V0z"></path>
        <path fill="#F35428" d="M127.271 0h-.106v7.842h.106V0z"></path>
        <path fill="#F35329" d="M127.378 0h-.107v7.842h.107V0z"></path>
        <path fill="#F35229" d="M127.485 0h-.107v7.842h.107V0z"></path>
        <path fill="#F3512A" d="M127.598 0h-.107v7.842h.107V0z"></path>
        <path fill="#F2502B" d="M127.705 0h-.107v7.842h.107V0z"></path>
        <path fill="#F24F2B" d="M127.818 0h-.107v7.842h.107V0z"></path>
        <path fill="#F24E2C" d="M127.925 0h-.107v7.842h.107V0z"></path>
        <path
          fill="#F24D2D"
          d="M128.032 0h-.107v7.842h.107V0zM128.145 0h-.106v7.842h.106V0z"
        ></path>
        <path fill="#F14C2E" d="M128.252 0h-.107v7.842h.107V0z"></path>
        <path fill="#F14B2F" d="M128.359 0h-.107v7.842h.107V0z"></path>
        <path fill="#F14A2F" d="M128.472 0h-.107v7.842h.107V0z"></path>
        <path fill="#F14930" d="M128.579 0h-.107v7.842h.107V0z"></path>
        <path fill="#F14831" d="M128.686 0h-.107v7.842h.107V0z"></path>
        <path fill="#F04831" d="M128.799 0h-.107v7.842h.107V0z"></path>
        <path fill="#F04732" d="M128.906 0h-.107v7.842h.107V0z"></path>
        <path fill="#F04632" d="M129.013 0h-.107v7.842h.107V0z"></path>
        <path
          fill="#F04533"
          d="M129.126 0h-.107v7.842h.107V0zM129.233 0h-.107v7.842h.107V0z"
        ></path>
        <path fill="#F04434" d="M129.34 0h-.107v7.842h.107V0z"></path>
        <path fill="#F04334" d="M129.453 0h-.107v7.842h.107V0z"></path>
        <path fill="#EF4335" d="M129.56 0h-.107v7.842h.107V0z"></path>
        <path
          fill="#EF4235"
          d="M129.666 0h-.106v7.842h.106V0zM129.78 0h-.107v7.842h.107V0z"
        ></path>
        <path
          fill="#EF4136"
          d="M129.887 0h-.107v7.842h.107V0zM130 0h-.106v7.842H130V0z"
        ></path>
      </g>
    </svg>
  );
}

export default LogoIcon;
